const formatPrice= (numberString) => numberString.replace(/\D+/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export default formatPrice;
